import React, { useState } from 'react';
import { NavLink }         from 'react-router-dom';
import { getRoute }        from 'pursuit/routes/routes';

export default function PageHeader() {
    const [menuOpen, setMenuOpen] = useState(false);

    const doCloseMenu = () => {
        setMenuOpen(false);
    }

    const doToggleMenu = () => {
        setMenuOpen(!menuOpen);
    }

    const menuClassName = menuOpen ? ' open' : '';

    return (
        <section className="page-header">
            <div className="page-header--branding">
                <NavLink
                    to={getRoute('home')}
                >
                    <div className="logo_horizontal mark" />
                    <div className="logo_horizontal wordmark" />
                </NavLink>
            </div>
            <div className={`page-header--menu${menuClassName}`}>
                <nav>
                    <ul>
                        <li><NavLink
                            to={getRoute('home')}
                            onClick={doCloseMenu}
                        >
                            Home
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('events')}
                            onClick={doCloseMenu}
                            // className={this.router.matchPath('/events.*') ? 'active' : null}
                        >
                            Events
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('aboutUs')}
                            onClick={doCloseMenu}
                        >
                            About Us
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('ourTeam')}
                            onClick={doCloseMenu}
                        >
                            Our Team
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('pricing')}
                            onClick={doCloseMenu}
                        >
                            Pricing
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('contact')}
                            onClick={doCloseMenu}
                        >
                            Contact
                        </NavLink></li>
                        <li><NavLink
                            to={getRoute('virtualAppointments')}
                            onClick={doCloseMenu}
                        >
                            Virtual Appointments
                        </NavLink></li>
                        <li className="xs-only">
                            <a
                                href="/booking"
                                target="_blank"
                                className="highlight"
                                onClick={doCloseMenu}
                            >
                                Book Services
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div className="page-header--phone-number justify-center">
                <div>
                    <a
                        href="/booking"
                        target="_blank"
                        className="button CTA"
                        onClick={doCloseMenu}
                    >
                        Book An Appointment
                    </a>
                    {/* <a
                        href="/classes"
                        target="_blank"
                        className="button CTA"
                        onClick={this.handleMenuClick}
                    >
                        Book Classes
                    </a> */}
                </div>
                <span className="highlight">
                    <a href="tel:+1-416-551-7326" className="highlight">+1 (416) 551-7326</a>
                </span>
            </div>
            <div
                className={`page-header--menu-toggle${menuClassName}`}
                onClick={doToggleMenu}
            >
                Menu <i className="icon-menu" /><i className="icon-arrow-up" />
            </div>
        </section>
    );
}
